import React, { useMemo } from 'react';
import { Card } from 'antd';
import SeoScore from '../../components/SeoReport/SeoScore';
import moment from 'moment';
import { AuditReportScoreData } from './types';

function getAuditSectionsStatusProgress(scoreData: AuditReportScoreData) {
    const totalSections = scoreData.failed + scoreData.passed + scoreData.warning;

    return {
        passed: (scoreData.passed * 100) / totalSections,
        warning: (scoreData.warning * 100) / totalSections,
        failed: (scoreData.failed * 100) / totalSections,
    };
}

type Props = {
    url: string;
    scoreData: AuditReportScoreData;
    createdAt: string;
};

export default function AuditReportSeoScore({ url, scoreData, createdAt }: Props) {
    const scoreDataProgress = useMemo(() => getAuditSectionsStatusProgress(scoreData), [scoreData]);

    return (
        <Card
            className="report-card summary"
            id="seo-score"
        >
            <div className="card-header">
                <Card.Meta
                    title={url}
                    description={`Report generated on ${moment(createdAt, 'YYYY-MM-DDTHH:mm:ss').format('MMM DD, YYYY')}`}
                />
            </div>

            <SeoScore
                seoScore={scoreData.score}
                sectionsStatusCounter={scoreData}
                sectionsStatusProgress={scoreDataProgress}
                inProgress={false}
                isFullReport={false}
            />
        </Card>
    );
}
